import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.planned

interface IPlannedOverviewCardProps {
  totalPlanned: number
  isUsd: boolean
  activeCurrency: string
}

export const PlannedOverviewCard = ({
  totalPlanned,
  isUsd,
  activeCurrency,
}: IPlannedOverviewCardProps) => (
  <MdfOverviewCard
    title={KEYS.title}
    replaceParams={[{ key: '{currency}', value: activeCurrency }]}
    value={getFormattedFinance(totalPlanned, {
      withCurrencySign: isUsd,
      maximumFractionDigits: 0,
    })}
    footer={<Translation text={KEYS.footerTitle} />}
  />
)

PlannedOverviewCard.displayName = 'PlannedOverviewCard'
